import React, { useCallback } from 'react';
import { Box, Button, ButtonGroup, TextField } from '@mui/material';

interface DateRangeSelectorProps {
  dataInicio: string;
  dataFim: string;
  onChange: (di: string, df: string) => void;
}

/** Formata Date para string YYYY-MM-DD */
const toISO = (d: Date): string => d.toISOString().slice(0, 10);

type Preset =
  | { label: string; dias: number }
  | { label: string; meses: number };

const PRESETS: readonly Preset[] = [
  { label: 'Hoje', dias: 0 },
  { label: '7 dias', dias: 7 },
  { label: '1 mes', meses: 1 },
  { label: '3 meses', meses: 3 },
  { label: '6 meses', meses: 6 },
  { label: '1 ano', meses: 12 },
] as const;

const DateRangeSelector: React.FC<DateRangeSelectorProps> = ({
  dataInicio,
  dataFim,
  onChange,
}) => {
  const handlePreset = useCallback(
    (preset: Preset) => {
      const fim = new Date();
      const inicio = new Date();
      if ('dias' in preset) {
        inicio.setDate(inicio.getDate() - preset.dias);
      } else {
        inicio.setMonth(inicio.getMonth() - preset.meses);
      }
      onChange(toISO(inicio), toISO(fim));
    },
    [onChange],
  );

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
      <ButtonGroup size="small" variant="outlined">
        {PRESETS.map((p) => (
          <Button key={p.label} onClick={() => handlePreset(p)}>
            {p.label}
          </Button>
        ))}
      </ButtonGroup>

      <TextField
        type="date"
        size="small"
        label="Inicio"
        value={dataInicio}
        onChange={(e) => onChange(e.target.value, dataFim)}
        InputLabelProps={{ shrink: true }}
        sx={{ width: 160 }}
      />

      <TextField
        type="date"
        size="small"
        label="Fim"
        value={dataFim}
        onChange={(e) => onChange(dataInicio, e.target.value)}
        InputLabelProps={{ shrink: true }}
        sx={{ width: 160 }}
      />
    </Box>
  );
};

export default DateRangeSelector;
